import { useState } from 'react'
import { Button } from '@/components/ui'

type Props = {
  onSave: (content: string) => void | Promise<void>
}

export function QuickWriteEditor({ onSave }: Props) {
  const [content, setContent] = useState('')
  const [isSaving, setIsSaving] = useState(false)

  const trimmed = content.trim()
  const canSave = trimmed.length > 0 && !isSaving

  async function handleSave() {
    if (!canSave) return
    setIsSaving(true)
    try {
      await onSave(trimmed)
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <div className="flex flex-col gap-4">
      <textarea
        autoFocus
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder="Start writing..."
        rows={12}
        className="w-full p-4 rounded-lg border border-[var(--color-kids-border)] bg-[var(--color-kids-surface)] text-[var(--color-kids-text)] font-body text-lg leading-relaxed focus:outline-none focus:ring-2 focus:ring-[var(--color-kids-primary)] resize-y"
      />
      <div className="flex justify-end">
        <Button onClick={handleSave} disabled={!canSave}>
          {isSaving ? 'Saving…' : 'Save'}
        </Button>
      </div>
    </div>
  )
}
